import { render, staticRenderFns } from "./LampConfig.vue?vue&type=template&id=0fa5de6a&"
import script from "./LampConfig.vue?vue&type=script&lang=js&"
export * from "./LampConfig.vue?vue&type=script&lang=js&"
import style0 from "./LampConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports